import { useState } from "react";


const useProfile = () => {
  return 1;
};

export { useProfile };
